// return the user data from the local storage
export const getUser = () => {
  const userStr = localStorage.getItem("user");
  if (userStr) {
    try {
      return JSON.parse(userStr); // Parse user data if it's valid JSON
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
      return null;
    }
  }
  return null;
};

// return the token from the local storage
export const getToken = () => {
  return localStorage.getItem("token") || null; // Return token if it exists, otherwise null
};

// remove the token and user from the local storage
export const removeUserSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
  localStorage.removeItem("hid");
};

// set the token and user in the local storage
export const setUserSession = (token, user) => {
  localStorage.setItem("token", token);
  localStorage.setItem("user", JSON.stringify(user)); // Store user as string
};

// set the token and user in the local storage
export const setUserHID = (hid) => {
  localStorage.setItem("hid", hid);
};

// get the user role ID from the local storage
export const getUserRoleID = () => {
  const userStr = localStorage.getItem("user");
  if (userStr) {
    try {
      const user = JSON.parse(userStr);
      return user.role_id; // Return the role ID if user exists
    } catch (error) {
      console.error("Error parsing user data from localStorage:", error);
      return null;
    }
  }
  return null;
};

// check if the token has expired (if expiry time is available in user object)
export const isTokenExpired = () => {
  const token = getToken();
  if (!token) return true; // If no token exists, it's considered expired
  
  // Example: If you store the token's expiry time in the user object, you can check here
  const user = getUser();
  if (user && user.token_expiry) {
    const expiryTime = new Date(user.token_expiry).getTime();
    const currentTime = new Date().getTime();
    return currentTime > expiryTime; // Compare current time with expiry time
  }
  
  return false; // Default return if no expiry is found
};
